import { call, put, takeLatest } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import api from '../../../core/api';
import { farmActions } from '../../actions';
import * as actions from './scaleType.actions';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { LoadersNames } from '../../ui/ui.constants';

export function* getScaleTypeListSaga() {
  yield put(showLoader(LoadersNames.fetchScaleTypes));
  try {
    const result = yield call(api.scaleType.getScaleTypeList, true);

    yield put(
      actions.getScaleTypeList.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
  yield put(hideLoader(LoadersNames.fetchScaleTypes));
}

export function* watchScaleTypeSaga() {
  // yield takeLatest(actions.getScaleTypeList.started, getScaleTypeListSaga);
  yield takeLatest(farmActions.getFarmsListRequest.done, getScaleTypeListSaga);
}
